<template>
  <div>
    <common-banner :imgSrc="imgPath" :imgLabel="imgLabel" :path="'/opendata'" :imgType='"scroll"'></common-banner>
    <home-content></home-content>
  </div>
</template>

<script>
    import CommonBanner from '@/pages/common/Banner'
    import BannerCarousel from '@/pages/common/BannerCarousel'
    import HomeContent from './components/HomeContent'

    export default {
        name: 'HomePage',
        components: {
            CommonBanner,
            BannerCarousel,
            HomeContent
        },
        data() {
            return {
                imgPath: require('@/assets/images/banner/dataset_banner.jpg'),
                imgLabel: '开放数林',
                images: [{
                    'id': 'banner3',
                    'path': require('@/assets/images/banner/dataset_banner.jpg'),
                    'title': 'banner'
                }, {
                    'id': 'banner1',
                    'path': require('@/assets/images/banner/banner-202002.jpg'),
                    'title': 'banner'
                }, {
                    'id': 'banner2',
                    'path': require('@/assets/images/banner/report-banner-2020.png'),
                    'title': 'banner'
                }]
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/homepage/HomePage.vue